import { render } from "./TextModal.vue?vue&type=template&id=0b25e693&scoped=true"
import script from "./TextModal.vue?vue&type=script&lang=js"
export * from "./TextModal.vue?vue&type=script&lang=js"

import "./TextModal.vue?vue&type=style&index=0&id=0b25e693&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b25e693"]])

export default __exports__